// Date 2021-06-09 10:13:09

import emEntityListView from "@/components/em/EmEntity/ListView";
import emEntityEditView from "@/components/em/EmEntity/EditView";
// import emWorkflowListView from "@/components/em/EmWorkflow/ListView";
// import emWorkflowTaskView from "@/components/em/EmWorkflow/TaskView";
// import emLevelTreeListView from "@/components/em/EmLevelTree/ListView";

import emAcctHandleRecordAhrEdit from "@/views/em/accident/EmAcctHandleRecordAhrEdit.vue";
import emAcctHandleRecordAhrList from "@/views/em/accident/EmAcctHandleRecordAhrList.vue";

import emAcctStatistics from "@/views/em/accident/EmAcctStatistics.vue";

const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
//公用组件注册
    {
        path: "/em/accident/emAcctLevel/list",
        name: "emAcctLevelList",
        component: emEntityListView,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/em/accident/emAcctLevel/edit",
        name: "emAcctLevelEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/accident/emAcctType/list",
        name: "emAcctTypeList",
        component: emEntityListView,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/em/accident/emAcctType/edit",
        name: "emAcctTypeEdit",
        component: emEntityEditView,
        meta: metaObject
    },
//自定义页面注册
    {
        path: "/em/accident/emAcctHandleRecordAhrEdit",
        name: "emAcctHandleRecordAhrEdit",
        component: emAcctHandleRecordAhrEdit,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/em/accident/emAcctHandleRecordAhrList",
        name: "emAcctHandleRecordAhrList",
        component: emAcctHandleRecordAhrList,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    //emAcctStatistics
    {
        path: "/em/accident/emAcctStatistics",
        name: "emAcctStatistics",
        component: emAcctStatistics,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    }
]